<template>
	<section ref="section"
			 class="flex-module container-fluid flexible-parallax-images">
		<div class="images-wrapper">
			<basePicture v-if="item.image_one"
						 ref="picOne"
						 class="firstimg so-paraimg"
						 :image="item.image_one"
						 :sizes="!!item.one_smaller ? 'xs:33vw md:33vw lg:33vw xl:33vw 2xl:33vw 3xl:33vw' : 'xs:50vw md:50vw lg:50vw xl:50vw 2xl:50vw 3xl:50vw'"
						 :width="item.image_one.width * 0.6"
						 :height="item.image_one.height"
						 fit="cover"
						 :class="{ 'smaller': item.one_smaller, 'bigger': !item.one_smaller }" />

			<basePicture v-if="item.image_two"
						 ref="picTwo"
						 class="firstimg so-paraimg"
						 :image="item.image_two"
						 :sizes="!!item.two_smaller ? 'xs:33vw md:33vw lg:33vw xl:33vw 2xl:33vw 3xl:33vw' : 'xs:50vw md:50vw lg:50vw xl:50vw 2xl:50vw 3xl:50vw'"
						 :width="item.image_two.width * 0.6"
						 :height="item.image_two.height"
						 fit="cover"
						 :class="{ 'smaller': item.two_smaller, 'bigger': !item.two_smaller }" />
		</div>
	</section>
</template>

<script setup>
import debounceFn from 'debounce-fn'

const props = defineProps({
	data: {
		type: Object,
		required: true
	}
})

const { $bus } = useNuxtApp()
const { gsap } = useGsap()
const sectionRef = useTemplateRef('section')
const triggers = {}
const item = computed(() => props.data.item)
let $q

function moveImages() {
	const biggerHeight = $q('.bigger')[0]?.clientHeight
	const smallerHeight = $q('.smaller')[0]?.clientHeight
	const toMoveSmall = smallerHeight ? (smallerHeight / 3) : (biggerHeight / 4)
	const toMoveBig = smallerHeight ? (smallerHeight / 4) : (biggerHeight / 5)
	const scrollDistanceAdjustment = smallerHeight ? (smallerHeight / 2) : (biggerHeight / 3)

	triggers.tl = gsap.timeline({
		scrollTrigger: {
			trigger: sectionRef.value,
			start: 'top bottom+=' + scrollDistanceAdjustment,
			end: 'bottom top+=' - scrollDistanceAdjustment,
			scrub: 1,
		}
	})
		.to($q('.smaller'), {
			y: (toMoveSmall * -1), // going up
		})
		.to($q('.bigger'), {
			y: toMoveBig * 1, // going down
		}, '<')
}

function revealImages() {
	gsap.timeline()
		.fromTo($q('picture'), {
			autoAlpha: 0,
		}, {
			autoAlpha: 1,
			duration: 0.5,
			stagger: 0.25,
			delay: 1.5,
		})
		.fromTo($q('picture'), {
			yPercent: 10,
		}, {
			yPercent: 0,
			duration: 0.75,
			stagger: 0.25,
		}, '<')
}

function initComponent() {
	$q = gsap.utils.selector(sectionRef.value)

	revealImages()
	moveImages()
}

function handleWindowResize() {
	triggers.tl.revert() // kill the existing timeline

	nextTick(() => {
		moveImages() // re-create the timeline with the new dimensions
		console.log('Window resized, parallax timelines refreshed')
	})
}

$bus.$on('window-resized', debounceFn(handleWindowResize, { wait: 250 }))


onMounted(() => {
	if (item.value.image_one || item.value.image_two) useAnims(initComponent, triggers)
})

onBeforeUnmount(() => {
	$bus.$off('window-resized', debounceFn(handleWindowResize, { wait: 250 }))
})
</script>

<style lang="scss" scoped>
.flexible-parallax-images {
	overflow: visible;
}

.so-paraimg {
	visibility: hidden;
}

.images-wrapper {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: flex-end;

	:deep(picture) {
		display: block;
		position: relative;
		bottom: 0;
		width: calc(50% - 1rem);
		// height: 65vw;
		overflow: hidden;
		aspect-ratio: 12/16;
		@include rounded-corners;

		&.bigger {
			@include smaller-margin-bottom;
		}

		&.smaller {
			width: calc(33% - 1rem);
			// height: 45vw;
			aspect-ratio: 12/16;
		}

		img {
			position: relative;
			height: 140%;
			width: 100%;
			object-fit: cover;
			object-position: center center;
			max-width: unset;

		}
	}
}
</style>
